import Select from 'antd/lib/select';
import { range } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { IconButton } from './icon-button.component';

const PageControlWrapper = styled.div`
  font-size: 16px;
  white-space: nowrap;

  .ant-select-selection {
    margin: 0 4px;
  }

  .page-icon-button {
    padding: 6px 8px;
  }
`;

interface PageSelectorProps {
  page: number;
  numberPages: number;
  onSelectPage: (page: number) => void;
}
const PageSelector = (props: PageSelectorProps) => {
  const { page, numberPages, onSelectPage } = props;

  return (
    <Select
      value={page.toString()}
      onChange={(pageNum: string) => onSelectPage(parseInt(pageNum, 10))}
    >
      {range(1, numberPages + 1).map(pageNum => (
        <Select.Option value={pageNum.toString()} key={pageNum.toString()}>
          {pageNum}
        </Select.Option>
      ))}
    </Select>
  );
};

export interface PageControlsProps {
  currentPage: number;
  numberPages: number;
  prevAnnotatedPage?: number | null;
  nextAnnotatedPage?: number | null;

  incrementClicked: () => any;
  decrementClicked: () => any;
  gotoPage: (page: number) => any;
}
export class PageControls extends React.Component<PageControlsProps> {
  render() {
    const {
      currentPage,
      numberPages,
      gotoPage,
      prevAnnotatedPage,
      nextAnnotatedPage,
    } = this.props;
    const pageSelector = (
      <PageSelector
        page={currentPage}
        numberPages={numberPages}
        onSelectPage={page => gotoPage(page)}
      />
    );
    const showAnnotatedNav =
      prevAnnotatedPage !== undefined || nextAnnotatedPage !== undefined;

    return (
      <PageControlWrapper>
        {showAnnotatedNav && (
          <IconButton
            className="page-icon-button"
            iconType="double-left"
            disabled={prevAnnotatedPage == null}
            onClick={() =>
              prevAnnotatedPage != null && gotoPage(prevAnnotatedPage)
            }
          />
        )}
        <IconButton
          className="page-icon-button"
          iconType="left"
          onClick={() => this.props.decrementClicked()}
        />
        Page {pageSelector} of {numberPages}
        <IconButton
          className="page-icon-button"
          iconType="right"
          onClick={() => this.props.incrementClicked()}
        />
        {showAnnotatedNav && (
          <IconButton
            className="page-icon-button"
            iconType="double-right"
            disabled={nextAnnotatedPage == null}
            onClick={() =>
              nextAnnotatedPage != null && gotoPage(nextAnnotatedPage)
            }
          />
        )}
      </PageControlWrapper>
    );
  }
}
